(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/logotype-provider/assets/javascripts/logotype-provider.js') >= 0) return;  svs.modules.push('/components/content/logotype-provider/assets/javascripts/logotype-provider.js');

'use strict';

var logotypes = svs.content && svs.content.logotypeProvider && svs.content.logotypeProvider.data && svs.content.logotypeProvider.data.logotypes || [];
svs.content.logotypeProvider = {
  getLogotype: function getLogotype(title) {
    return logotypes.find(function (logotype) {
      return logotype.title === title;
    });
  },
  getLogotypes: function getLogotypes() {
    return logotypes;
  },
  getLogotypesList: function getLogotypesList() {
    return logotypes.length && logotypes.map(function (logotype) {
      return logotype.title;
    });
  }
};

 })(window);